export const MATERNITY_REGISTRATION_STORAGE_KEY = 'mfo_registration_draft';
export const MATERNITY_REGISTRATION_ALLOWED_KEY = 'mfo_registration_allowed';
